import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section className="bg-foreground-950 py-12 md:py-16">
      <div className="px-6 md:px-12">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
          <div className="flex-shrink-0 relative" ref={dropdownRef}>
            <button
              onClick={() => setOpen(!open)}
              className="inline-flex items-center gap-2 border border-background-50/20 text-background-50 px-5 py-2.5 rounded-full text-sm font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              Categorie
              {open ? (
                <i className="ri-arrow-up-s-line w-4 h-4 flex items-center justify-center"></i>
              ) : (
                <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center"></i>
              )}
            </button>

            {open && (
              <div className="absolute left-6 md:left-12 mt-3 bg-background-50 rounded-lg p-4 z-40 shadow-sm border border-background-200/70 min-w-[340px] grid grid-cols-1 sm:grid-cols-2 gap-1">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50 px-3 py-2 rounded-md transition-colors cursor-pointer group"
                  >
                    <span className="flex-shrink-0 w-9 h-9 rounded-md overflow-hidden bg-background-200">
                      <img
                        src={cat.image}
                        alt={cat.nameIt}
                        className="w-full h-full object-cover transition-transform group-hover:scale-110"
                      />
                    </span>
                    <div className="flex flex-col">
                      <span className="font-medium text-foreground-900">{cat.nameIt}</span>
                      <span className="text-foreground-400 text-xs">{cat.name}</span>
                    </div>
                  </a>
                ))}
              </div>
            )}
          </div>

          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
              Tutte le
              <br className="hidden md:block" />
              <span className="text-accent-500"> categorie 2026</span>
            </h2>
          </div>
        </div>

        <div className="mt-8 flex gap-4 overflow-x-auto pb-4">
          {categories.slice(0, 6).map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-44 md:w-52 group cursor-pointer"
            >
              <div className="bg-background-100 rounded-lg overflow-hidden">
                <div className="w-full h-32 md:h-36">
                  <img
                    src={cat.image}
                    alt={cat.nameIt}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="bg-foreground-900 p-3">
                  <p className="text-background-50 text-sm font-semibold">{cat.nameIt}</p>
                  <p className="text-background-50/60 text-xs mt-0.5">{cat.name}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}